var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.753,
    height: 15.747,
    viewBox: "0 0 15.753 15.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Export",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72199",
    "data-name": "Path 72199",
    d: "M17.084,16.65a.665.665,0,0,0-.663.663v3.2a.938.938,0,0,1-.938.938H4.27a.938.938,0,0,1-.938-.938v-3.2a.666.666,0,0,0-1.332,0v3.2a2.271,2.271,0,0,0,2.27,2.27H15.483a2.271,2.271,0,0,0,2.27-2.27v-3.2A.675.675,0,0,0,17.084,16.65Z",
    transform: "translate(0 -5.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72200",
    "data-name": "Path 72200",
    d: "M16.026,6.2l-4-4a.665.665,0,0,0-.945,0l-4,4a.668.668,0,1,0,.945.945l3.53-3.536,3.536,3.536a.669.669,0,0,0,1.142-.472A.707.707,0,0,0,16.026,6.2Z",
    transform: "translate(-1.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72201",
    "data-name": "Path 72201",
    d: "M13.653,2a.666.666,0,0,0-.663.669v9.612a.663.663,0,1,0,1.325,0V2.669A.666.666,0,0,0,13.653,2Z",
    transform: "translate(-3.779)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.57471f9faf94599a0a6ddbab5daefba6.svg";
export { ForwardRef as ReactComponent };